import {COUNTRIES} from '../constants/AppConstants';
import {Catalog} from '../../common/types/common';

export const SET_LOAN_APPLICATION_TOKEN_ACTION = {
    name: 'SET_LOAN_APPLICATION_TOKEN_ACTION',
    action: token => ({
        token,
        type: SET_LOAN_APPLICATION_TOKEN_ACTION.name
    })
};

export const SET_LOAN_APPLICATION_TOKEN_TC_ACTION = {
    name: 'SET_LOAN_APPLICATION_TOKEN_TC_ACTION',
    action: token => ({
        token,
        type: SET_LOAN_APPLICATION_TOKEN_TC_ACTION.name
    })
};

export const CHANGE_FIRST_NAME_ACTION = {
    name: 'CHANGE_FIRST_NAME_ACTION',
    action: (firstName, error, country = COUNTRIES.MX.id) => ({
        firstName, error, country,
        type: CHANGE_FIRST_NAME_ACTION.name
    })
};

export const CHANGE_SECOND_NAME_ACTION = {
    name: 'CHANGE_SECOND_NAME_ACTION',
    action: (secondName, error, country = COUNTRIES.MX.id) => ({
        secondName, error, country,
        type: CHANGE_SECOND_NAME_ACTION.name
    })
};

export const CHANGE_LAST_NAME_ACTION = {
    name: 'CHANGE_LAST_NAME_ACTION',
    action: (lastName, error, country = COUNTRIES.MX.id) => ({
        lastName, error, country,
        type: CHANGE_LAST_NAME_ACTION.name
    })
};

export const CHANGE_SECOND_LAST_NAME_ACTION = {
    name: 'CHANGE_SECOND_LAST_NAME_ACTION',
    action: (secondLastName, error, country = COUNTRIES.MX.id) => ({
        secondLastName, error, country,
        type: CHANGE_SECOND_LAST_NAME_ACTION.name
    })
};

export const CHANGE_BIRTH_DATE_ACTION = {
    name: 'CHANGE_BIRTH_DATE_ACTION',
    action: (birthDate, error, country = COUNTRIES.MX.id) => ({
        birthDate, error, country,
        type: CHANGE_BIRTH_DATE_ACTION.name
    })
};

export const CHANGE_DOC_NUMBER_ACTION = {
    name: 'CHANGE_DOC_NUMBER_ACTION',
    action: (docNumber, error) => ({
        docNumber, error,
        type: CHANGE_DOC_NUMBER_ACTION.name
    })
};

export const CHANGE_CELL_PHONE_ACTION = {
    name: 'CHANGE_CELL_PHONE_ACTION',
    action: (cellPhone, error) => ({
        cellPhone, error,
        type: CHANGE_CELL_PHONE_ACTION.name
    })
};

export const CHANGE_EMAIL_ACTION = {
    name: 'CHANGE_EMAIL_ACTION',
    action: email => ({
        email,
        type: CHANGE_EMAIL_ACTION.name
    })
};

export const CHANGE_GENDER_ACTION = {
    name: 'CHANGE_GENDER_ACTION',
    action: (gender, error) => ({
        gender, error,
        type: CHANGE_GENDER_ACTION.name
    })
};

export const CHANGE_ECONOMIC_DEPENDENTS_ACTION = {
    name: 'CHANGE_ECONOMIC_DEPENDENTS_ACTION',
    action: (economicDependents, error) => ({
        economicDependents, error,
        type: CHANGE_ECONOMIC_DEPENDENTS_ACTION.name
    })
};

export const CHANGE_ALREADY_HAS_VEHICLE_ACTION = {
    name: 'CHANGE_ALREADY_HAS_VEHICLE_ACTION',
    action: (alreadyHasVehicle, error) => ({
        alreadyHasVehicle, error,
        type: CHANGE_ALREADY_HAS_VEHICLE_ACTION.name
    })
};

export const CHANGE_NATIONALITY_ACTION = {
    name: 'CHANGE_NATIONALITY_ACTION',
    action: (nationality: Catalog, error: string = null) => ({
        nationality, error,
        type: CHANGE_NATIONALITY_ACTION.name
    })
};

export const CHANGE_ACCEPT_TERMS_ACTION = {
    name: 'CHANGE_ACCEPT_TERMS_ACTION',
    action: acceptTerms => ({
        acceptTerms,
        type: CHANGE_ACCEPT_TERMS_ACTION.name
    })
};

export const CHANGE_RECEIVE_NEWS_PROMOTIONS_ACTION = {
    name: 'CHANGE_RECEIVE_NEWS_PROMOTIONS_ACTION',
    action: receiveNewsPromotions => ({
        receiveNewsPromotions,
        type: CHANGE_RECEIVE_NEWS_PROMOTIONS_ACTION.name
    })
};

export const CHANGE_OTHER_REFERENCES_ACTION = {
    name: 'CHANGE_OTHER_REFERENCES_ACTION',
    action: otherReferences => ({
        otherReferences,
        type: CHANGE_OTHER_REFERENCES_ACTION.name
    })
};

export const CHANGE_OTHER_REFERENCES_TC_ACTION = {
    name: 'CHANGE_OTHER_REFERENCES_TC_ACTION',
    action: otherReferences => ({
        otherReferences,
        type: CHANGE_OTHER_REFERENCES_TC_ACTION.name
    })
};

export const CHANGE_HOME_ADDRESS_ACTION = {
    name: 'CHANGE_HOME_ADDRESS_ACTION',
    action: (address, error = null) => ({
        address, error,
        type: CHANGE_HOME_ADDRESS_ACTION.name
    })
};

export const CHANGE_HOME_EXT_NUMBER_ACTION = {
    name: 'CHANGE_HOME_EXT_NUMBER_ACTION',
    action: (extNumber, error = null) => ({
        extNumber, error,
        type: CHANGE_HOME_EXT_NUMBER_ACTION.name
    })
};

export const CHANGE_HOME_INT_NUMBER_ACTION = {
    name: 'CHANGE_HOME_INT_NUMBER_ACTION',
    action: (intNumber, error = null) => ({
        intNumber, error,
        type: CHANGE_HOME_INT_NUMBER_ACTION.name
    })
};

export const CHANGE_HOME_POSTAL_CODE_ACTION = {
    name: 'CHANGE_HOME_POSTAL_CODE_ACTION',
    action: (postalCode, country, error) => ({
        postalCode, country, error,
        type: CHANGE_HOME_POSTAL_CODE_ACTION.name
    })
};

export const CHANGE_CALCULATOR_POSTAL_CODE_ACTION = {
    name: 'CHANGE_CALCULATOR_POSTAL_CODE_ACTION',
    action: (postalCode, error) => ({
        postalCode, error,
        type: CHANGE_CALCULATOR_POSTAL_CODE_ACTION.name
    })
};

export const CHANGE_HOME_STATES_ACTION = {
    name: 'CHANGE_HOME_STATES_ACTION',
    action: (state, error = null) => ({
        state, error,
        type: CHANGE_HOME_STATES_ACTION.name
    })
};

export const CHANGE_HOME_CITY_ACTION = {
    name: 'CHANGE_HOME_CITY_ACTION',
    action: (city, error = null) => ({
        city, error,
        type: CHANGE_HOME_CITY_ACTION.name
    })
};

export const CHANGE_HOME_MUNICIPALITY_ACTION = {
    name: 'CHANGE_HOME_MUNICIPALITY_ACTION',
    action: (municipality, error = null) => ({
        municipality, error,
        type: CHANGE_HOME_MUNICIPALITY_ACTION.name
    })
};

export const CHANGE_HOME_COLONIES_ACTION = {
    name: 'CHANGE_HOME_COLONIES_ACTION',
    action: (colonies, error = null) => ({
        colonies, error,
        type: CHANGE_HOME_COLONIES_ACTION.name
    })
};

export const CHANGE_HOME_PHONE_ACTION = {
    name: 'CHANGE_HOME_PHONE_ACTION',
    action: (phone, error = null) => ({
        phone, error,
        type: CHANGE_HOME_PHONE_ACTION.name
    })
};

export const CHANGE_HOME_COLONY_MX_ACTION = {
    name: 'CHANGE_HOME_COLONY_MX_ACTION',
    action: (colony, error = null) => ({
        colony, error,
        type: CHANGE_HOME_COLONY_MX_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION = {
    name: 'CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION',
    action: (documentType, error = null) => ({
        documentType, error,
        type: CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION = {
    name: 'CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION',
    action: (businessType, error = null) => ({
        businessType, error,
        type: CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_BILLING_TYPE_ACTION = {
    name: 'CHANGE_EMPLOYMENT_BILLING_TYPE_ACTION',
    action: (billingType, error = null) => ({
        billingType, error,
        type: CHANGE_EMPLOYMENT_BILLING_TYPE_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_TAX_REGIME_ACTION = {
    name: 'CHANGE_EMPLOYMENT_TAX_REGIME_ACTION',
    action: (taxRegime, error = null) => ({
        taxRegime, error,
        type: CHANGE_EMPLOYMENT_TAX_REGIME_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_COLONY_MX_ACTION = {
    name: 'CHANGE_EMPLOYMENT_COLONY_MX_ACTION',
    action: (colony, error = null) => ({
        colony, error,
        type: CHANGE_EMPLOYMENT_COLONY_MX_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_COLONY_MX_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_COLONY_MX_TC_ACTION',
    action: (colony, error = null) => ({
        colony, error,
        type: CHANGE_EMPLOYMENT_COLONY_MX_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION',
    action: (workplaceName, error = null) => ({
        workplaceName, error,
        type: CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKPLACE_NAME_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKPLACE_NAME_TC_ACTION',
    action: (workplaceName, error = null) => ({
        workplaceName, error,
        type: CHANGE_EMPLOYMENT_WORKPLACE_NAME_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_POSITION_ACTION = {
    name: 'CHANGE_EMPLOYMENT_POSITION_ACTION',
    action: (position, error = null) => ({
        position, error,
        type: CHANGE_EMPLOYMENT_POSITION_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_POSITION_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_POSITION_TC_ACTION',
    action: (position, error = null) => ({
        position, error,
        type: CHANGE_EMPLOYMENT_POSITION_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION',
    action: (workingSince, error = null) => ({
        workingSince, error,
        type: CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKING_SINCE_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKING_SINCE_TC_ACTION',
    action: (workingSince, error = null) => ({
        workingSince, error,
        type: CHANGE_EMPLOYMENT_WORKING_SINCE_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_ROTATION_ACTION = {
    name: 'CHANGE_EMPLOYMENT_ROTATION_ACTION',
    action: (employmentRotation, error = null) => ({
        employmentRotation, error,
        type: CHANGE_EMPLOYMENT_ROTATION_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_ADDRESS_ACTION = {
    name: 'CHANGE_EMPLOYMENT_ADDRESS_ACTION',
    action: (address, error = null) => ({
        address, error,
        type: CHANGE_EMPLOYMENT_ADDRESS_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_ADDRESS_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_ADDRESS_TC_ACTION',
    action: (address, error = null) => ({
        address, error,
        type: CHANGE_EMPLOYMENT_ADDRESS_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION = {
    name: 'CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION',
    action: (extNumber, error = null) => ({
        extNumber, error,
        type: CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_EXT_NUMBER_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_EXT_NUMBER_TC_ACTION',
    action: (extNumber, error = null) => ({
        extNumber, error,
        type: CHANGE_EMPLOYMENT_EXT_NUMBER_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_INT_NUMBER_ACTION = {
    name: 'CHANGE_EMPLOYMENT_INT_NUMBER_ACTION',
    action: (intNumber, error = null) => ({
        intNumber, error,
        type: CHANGE_EMPLOYMENT_INT_NUMBER_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_INT_NUMBER_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_INT_NUMBER_TC_ACTION',
    action: (intNumber, error = null) => ({
        intNumber, error,
        type: CHANGE_EMPLOYMENT_INT_NUMBER_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_STREET_BETWEEN_ACTION = {
    name: 'CHANGE_EMPLOYMENT_STREET_BETWEEN_ACTION',
    action: (streetBetween, error = null) => ({
        streetBetween, error,
        type: CHANGE_EMPLOYMENT_STREET_BETWEEN_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION = {
    name: 'CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION',
    action: (postalCode, country, error = null) => ({
        postalCode, country, error,
        type: CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION',
    action: (postalCode, country, error = null) => ({
        postalCode, country, error,
        type: CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION',
    action: (index, postalCode, country, error) => ({
        index, postalCode, country, error,
        type: CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION',
    action: (workplacePhone, error = null) => ({
        workplacePhone, error,
        type: CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKPLACE_PHONE_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKPLACE_PHONE_TC_ACTION',
    action: (workplacePhone, error = null) => ({
        workplacePhone, error,
        type: CHANGE_EMPLOYMENT_WORKPLACE_PHONE_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION',
    action: (workplacePhoneExt, error = null) => ({
        workplacePhoneExt, error,
        type: CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_TC_ACTION',
    action: (workplacePhoneExt, error = null) => ({
        workplacePhoneExt, error,
        type: CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION = {
    name: 'CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION',
    action: (monthlyIncomes, error = null) => ({
        monthlyIncomes, error,
        type: CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_MONTHLY_INCOMES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_MONTHLY_INCOMES_TC_ACTION',
    action: (monthlyIncomes, error = null) => ({
        monthlyIncomes, error,
        type: CHANGE_EMPLOYMENT_MONTHLY_INCOMES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_STATES_ACTION = {
    name: 'CHANGE_EMPLOYMENT_STATES_ACTION',
    action: (state, error = null) => ({
        state, error,
        type: CHANGE_EMPLOYMENT_STATES_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_STATES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_STATES_TC_ACTION',
    action: (state, error = null) => ({
        state, error,
        type: CHANGE_EMPLOYMENT_STATES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_STATES_REFERENCES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_STATES_REFERENCES_TC_ACTION',
    action: (index, state, error = null) => ({
        index, state, error,
        type: CHANGE_EMPLOYMENT_STATES_REFERENCES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_CITY_ACTION = {
    name: 'CHANGE_EMPLOYMENT_CITY_ACTION',
    action: (city, error = null) => ({
        city, error,
        type: CHANGE_EMPLOYMENT_CITY_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_CITY_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_CITY_TC_ACTION',
    action: (city, error = null) => ({
        city, error,
        type: CHANGE_EMPLOYMENT_CITY_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_CITY_REFERENCES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_CITY_REFERENCES_TC_ACTION',
    action: (index, city, error = null) => ({
        index, city, error,
        type: CHANGE_EMPLOYMENT_CITY_REFERENCES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION = {
    name: 'CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION',
    action: (municipality, error = null) => ({
        municipality, error,
        type: CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION',
    action: (municipality, error = null) => ({
        municipality, error,
        type: CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_MUNICIPALITY_REFERENCES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_MUNICIPALITY_REFERENCES_TC_ACTION',
    action: (index, municipality, error = null) => ({
        index, municipality, error,
        type: CHANGE_EMPLOYMENT_MUNICIPALITY_REFERENCES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_COLONIES_ACTION = {
    name: 'CHANGE_EMPLOYMENT_COLONIES_ACTION',
    action: (colonies, error = null) => ({
        colonies, error,
        type: CHANGE_EMPLOYMENT_COLONIES_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_COLONIES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_COLONIES_TC_ACTION',
    action: (colonies, error = null) => ({
        colonies, error,
        type: CHANGE_EMPLOYMENT_COLONIES_TC_ACTION.name
    })
};

export const CHANGE_EMPLOYMENT_COLONIES_REFERENCES_TC_ACTION = {
    name: 'CHANGE_EMPLOYMENT_COLONIES_REFERENCES_TC_ACTION',
    action: (index, colonies, error = null) => ({
        index, colonies, error,
        type: CHANGE_EMPLOYMENT_COLONIES_REFERENCES_TC_ACTION.name
    })
};

export const GOT_LOCATIONS_APPLICANT_HOME_MX_ACTION = {
    name: 'GOT_LOCATIONS_APPLICANT_HOME_MX_ACTION',
    action: location => ({
        location,
        type: GOT_LOCATIONS_APPLICANT_HOME_MX_ACTION.name
    })
};

export const GOT_LOCATIONS_APPLICANT_EMPLOYMENT_MX_ACTION = {
    name: 'GOT_LOCATIONS_APPLICANT_EMPLOYMENT_MX_ACTION',
    action: location => ({
        location,
        type: GOT_LOCATIONS_APPLICANT_EMPLOYMENT_MX_ACTION.name
    })
};

export const CHANGE_INCLUDE_MONTHLY_INCOMES = {
    name: 'CHANGE_INCLUDE_MONTHLY_INCOMES',
    action: (includeMonthlyIncomes, monthlyIncomes) => ({
        includeMonthlyIncomes, monthlyIncomes,
        type: CHANGE_INCLUDE_MONTHLY_INCOMES.name
    })
};

export const CHANGE_EMPLOYMENT_TYPES_INCOMES = {
    name: 'CHANGE_EMPLOYMENT_TYPES_INCOMES',
    action: (employmentType, error) => ({
        employmentType, error,
        type: CHANGE_EMPLOYMENT_TYPES_INCOMES.name
    })
};

export const CHANGE_CIVIL_STATUS_ACTION = {
    name: 'CHANGE_CIVIL_STATUS_ACTION',
    action: (civilStatus, error) => ({
        civilStatus, error,
        type: CHANGE_CIVIL_STATUS_ACTION.name
    })
};

export const CHANGE_REGIME_ACTION = {
    name: 'CHANGE_REGIME_ACTION',
    action: (regime, error) => ({
        regime, error,
        type: CHANGE_REGIME_ACTION.name
    })
};

export const CHANGE_ROL_HOME_ACTION = {
    name: 'CHANGE_ROL_HOME_ACTION',
    action: (rolHome, error) => ({
        rolHome, error,
        type: CHANGE_ROL_HOME_ACTION.name
    })
};

export const CHANGE_STUDIES_ACTION = {
    name: 'CHANGE_STUDIES_ACTION',
    action: (studies, error) => ({
        studies, error,
        type: CHANGE_STUDIES_ACTION.name
    })
};

export const CHANGE_HOUSE_TYPE_ACTION = {
    name: 'CHANGE_HOUSE_TYPE_ACTION',
    action: (houseType, error) => ({
        houseType, error,
        type: CHANGE_HOUSE_TYPE_ACTION.name
    })
};

export const CHANGE_AMOUNT_DEPENDENTS_ACTION = {
    name: 'CHANGE_AMOUNT_DEPENDENTS_ACTION',
    action: (amountDependents, error) => ({
        amountDependents, error,
        type: CHANGE_AMOUNT_DEPENDENTS_ACTION.name
    })
};

export const CHANGE_CURP_ACTION = {
    name: 'CHANGE_CURP_ACTION',
    action: (cURP, error) => ({
        cURP, error,
        type: CHANGE_CURP_ACTION.name
    })
};

export const CHANGE_HOUSEHOLD_TIME_ACTION = {
    name: 'CHANGE_HOUSEHOLD_TIME_ACTION',
    action: (houseHoldTime, error) => ({
        houseHoldTime, error,
        type: CHANGE_HOUSEHOLD_TIME_ACTION.name
    })
};

export const CHANGE_HOUSEHOLD_MEASURE_ACTION = {
    name: 'CHANGE_HOUSEHOLD_MEASURE_ACTION',
    action: (houseHoldMeasure, error) => ({
        houseHoldMeasure, error,
        type: CHANGE_HOUSEHOLD_MEASURE_ACTION.name
    })
};

export const CHANGE_CREDIT_HISTORY_OPTIONS_ACTION = {
    name: 'CHANGE_CREDIT_HISTORY_OPTIONS_ACTION',
    action: bureauOption => ({
        bureauOption,
        type: CHANGE_CREDIT_HISTORY_OPTIONS_ACTION.name
    })
};

export const CHANGE_BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS_ACTION = {
    name: 'CHANGE_BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS_ACTION',
    action: bureauOptionCreditCardLastDigits => ({
        bureauOptionCreditCardLastDigits,
        type: CHANGE_BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS_ACTION.name
    })
};

export const CHANGE_INCLUDE_INSURANCE_ACTION = {
    name: 'CHANGE_INCLUDE_INSURANCE_ACTION',
    action: includeInsurance => ({
        includeInsurance,
        type: CHANGE_INCLUDE_INSURANCE_ACTION.name
    })
};

export const CHANGE_INSURANCE_ACTION = {
    name: 'CHANGE_INSURANCE_ACTION',
    action: insuranceSelected => ({
        insuranceSelected,
        type: CHANGE_INSURANCE_ACTION.name
    })
};

export const PROCESS_FILES_TO_UPLOAD_ACTION = {
    name: 'PROCESS_FILES_TO_UPLOAD_ACTION',
    action: (files, fileType, fileSection, error, bank) => ({
        files, fileType, fileSection, error, bank,
        type: PROCESS_FILES_TO_UPLOAD_ACTION.name
    })
};

export const UPLOAD_FILES_ACTION = {
    name: 'UPLOAD_FILES_ACTION',
    action: (files, bank, fileType) => ({
        files, bank, fileType,
        type: UPLOAD_FILES_ACTION.name
    })
};

export const UPLOADED_FILES_ACTION = {
    name: 'UPLOADED_FILES_ACTION',
    action: files => ({
        files,
        type: UPLOADED_FILES_ACTION.name
    })
};

export const UPLOADED_FILES_TC_ACTION = {
    name: 'UPLOADED_FILES_TC_ACTION',
    action: files => ({
        files,
        type: UPLOADED_FILES_TC_ACTION.name
    })
};

export const DELETE_FILE_ACTION = {
    name: 'DELETE_FILE_ACTION',
    action: (fileId, fileType, bank) => ({
        fileId, fileType, bank,
        type: DELETE_FILE_ACTION.name
    })
};

export const SET_EMPLOYMENT_STATE_ACTION = {
    name: 'SET_EMPLOYMENT_STATE_ACTION',
    action: employmentData => ({
        employmentData,
        type: SET_EMPLOYMENT_STATE_ACTION.name
    })
};
